module.exports = __webpack_public_path__ + "img/bin-c-1.80527a88.svg";